import { render, staticRenderFns } from "./ShopStockItem.vue?vue&type=template&id=5da60e0f"
import script from "./ShopStockItem.vue?vue&type=script&lang=js"
export * from "./ShopStockItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5da60e0f')) {
      api.createRecord('5da60e0f', component.options)
    } else {
      api.reload('5da60e0f', component.options)
    }
    module.hot.accept("./ShopStockItem.vue?vue&type=template&id=5da60e0f", function () {
      api.rerender('5da60e0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/ShopStockItem.vue"
export default component.exports